/**
 * locale — SOURCE UNIQUE de la locale de formatage (dates, nombres, devises).
 *
 * Bilinguisme Lot 1d (2026-08-02, docs/AUDIT_BILINGUISME_2026-08-02.md) :
 * l'audit a relevé 252 occurrences de 'fr-FR' codées en dur dans 97 fichiers —
 * dates et montants restaient français en mode EN. Règle : plus JAMAIS de
 * locale littérale dans un composant ; toujours ces helpers, qui suivent la
 * langue active d'i18next à CHAQUE appel.
 */
import i18n from '../i18n';

/** Locale BCP 47 courante, dérivée de la langue active. */
export const currentLocale = () => (i18n.language?.startsWith('en') ? 'en-US' : 'fr-FR');

/** Date localisée — remplace `new Date(x).toLocaleDateString('fr-FR', opts)`. */
export const formatDate = (valeur, options) => new Date(valeur).toLocaleDateString(currentLocale(), options);


/**
 * Date SANS heure (colonne `date`) : affichée telle quelle, sans décalage de fuseau.
 * `new Date('2026-03-02')` vaut minuit UTC et s'afficherait la veille à l'ouest de Greenwich ;
 * ici le jour est construit dans le fuseau local, donc le 2 mars reste le 2 mars partout.
 */
export const formatJour = (valeur, options) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(valeur ?? ''));
  if (!m) return valeur ? formatDate(valeur, options) : '—';
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString(currentLocale(), options);
};
